// Responses per topic describes the whole conversation, so the strip offers it only on the Entire
// conversation overview. A block showing it when a turn is picked -- by the reader, or by a report
// saved that way -- moves to the view the strip opens on, before it paints; the switch keeps the turn.

import { useLayoutEffect } from 'react'

export default function useChartOnOverview({ viewMode, controlsProps }) {
  const viewModes = controlsProps?.data?.controls?.viewModes
  const onViewModeChange = controlsProps?.onViewModeChange
  const offered = viewModes?.options?.some(option => 'chart' === option.key)
  const fallback = viewModes?.default

  useLayoutEffect(() => {
    if ('chart' !== viewMode || offered || !viewModes || null == fallback) return

    onViewModeChange?.(fallback)
  }, [viewMode, offered, fallback, viewModes, onViewModeChange])
}
